import { css as o } from "styled-components";
const t = ({ theme: l }) => /* @__PURE__ */ o([
  "",
  ""
], l.globalStyles);
export {
  t as default
};
